import { Injectable, signal } from '@angular/core';
import { BottomBarButton } from '../bottom-bar.component';

@Injectable({
  providedIn: 'root',
})
export class BottomBarFilterActiveService {
  bottomBarButtons = signal<BottomBarButton[]>([]);

  resetActive() {
    this.bottomBarButtons.update(list => list.map(btn => ({ ...btn, active: false })));
  }

  deactivate(index: number) {
    this.bottomBarButtons.update(list => list.map((btn, i) => (i === index ? { ...btn, active: false } : btn)));
  }

  constructor() {}
}
